export class Parroquia {
    codParroquia: number;
    nomParroquia: string;
    codCanton: number;
    codProvincia: number;
}
